//Activity Codes
export const STRAIGHT_TIME_ATTENDANCE_CODE = '0099';
export const MEAL_BREAK_ABSENCE_CODE = '9165';
export const OVERTIME_ATTENDANCE_CODE = '0069';
export const DOUBLE_TIME_ATTENDANCE_CODE = '0068';
export const SPECIAL_ACCRUAL_OVERTIME_ATTENDANCE_CODE = '0070';
export const SPECIAL_ACCRUAL_DOUBLE_TIME_ATTENDANCE_CODE = '0071';

//Override Codes
export const OVERTIME_AUTOMATION_OVERRIDE_CODE = '9300';
